import { alertActions } from ".";
import { userConstants } from "../constants";

import { hashPassphrase, authHeader } from "../helpers";

import { UserInfo } from "../contracts/UserInfo";
import { AuthorityService, UserService } from "../services/authority.service";

import { ILocalizedError, LocalizeMessage } from "../i18n/error-localization";
import { History } from "history";
import { ResetPasswordResult } from 'src/contracts/IResetPasswordState';

function myFetch(url: RequestInfo, init?: RequestInit): Promise<Response> {
  if (!init || !init.headers) {
    return fetch(url, init);
  }

  const newInit: RequestInit = {
    ...init,
    credentials: "omit",
    headers: { ...init.headers, Authorization: authHeader() },
    mode: "cors"
  };

  console.log("newinit", newInit);

  return fetch(url, newInit);
}

export const loginRequestAction = (username: string, password: string, history: any) => (dispatch: any) => {
  const authEndpoint = `${process.env.REACT_APP_AUTH_ENDPOINT}`;
  const authService = new AuthorityService(authEndpoint);

  dispatch(loginRequestInitiated(username));

  const tokenRequest: { [key: string]: string } | null | undefined = {
    grant_type: "password",
    password: hashPassphrase(password),
    username
  };

  authService
    .requestToken(tokenRequest as any, undefined, "web")
    .then(
      accessToken => {
        if (!accessToken || !accessToken.access_token) {
          throw new Error("Authorization failed.");
        }

        const userInfo: UserInfo = new UserInfo(username, accessToken.access_token);
        dispatch(loginTokenReceived(userInfo));

        const userService = new UserService(authEndpoint, { fetch: myFetch });
        return userService.get().then(
          user => {
            dispatch(loginRequestCompleted(userInfo));
            history.push("/");
          },
          error => {
            dispatch(loginRequestFailed(LocalizeMessage(error)));
            dispatch(alertActions.error(LocalizeMessage(error)));
          }
        );
      },
      error => {
        dispatch(loginRequestFailed(LocalizeMessage(error)));
        dispatch(alertActions.error(LocalizeMessage(error)));
      }
    )
    .catch(error => {
      dispatch(loginRequestFailed(LocalizeMessage(error)));
      dispatch(alertActions.error(LocalizeMessage(error)));
    });
};

export const resetPassword = (login: string) => (dispatch: any) => {
  const authEndpoint = `${process.env.REACT_APP_AUTH_ENDPOINT}`;
  const userService = new UserService(authEndpoint);

  dispatch(resetPasswordRequest())
  userService.resetPassword(login).then(response => {
    dispatch(resetPasswordSuccess())
  })
  .catch(error => {
    dispatch(resetPasswordFailure(ResetPasswordResult.Other, LocalizeMessage(error)))
  })
}

export const loginFailedAction = (error: ILocalizedError) => (dispatch: any) => {
  dispatch(loginRequestFailed(error));
  dispatch(alertActions.error(error));
};

export const logoutAction = (history: History) => (dispatch: any) => {
  localStorage.removeItem("user");
  history.push("/login");
  dispatch(logoutCompleted());
};

const loginRequestInitiated = (user: string) => ({
  payload: user,
  type: userConstants.LOGIN_REQUEST
});

const loginTokenReceived = (userInfo: UserInfo) => ({
  payload: userInfo,
  type: userConstants.LOGIN_TOKEN_RECEIVED
});

const loginRequestCompleted = (userInfo: UserInfo) => ({
  payload: userInfo,
  type: userConstants.LOGIN_SUCCESS
});

const loginRequestFailed = (error: ILocalizedError) => ({
  payload: error,
  type: userConstants.LOGIN_FAILURE
});

const logoutCompleted = () => ({
  type: userConstants.LOGOUT
});

const resetPasswordRequest = () =>({
  type: userConstants.RESET_PASSWORD_REQUEST
})

const resetPasswordSuccess = () =>({
  type: userConstants.RESET_PASSWORD_SUCCESS
})

const resetPasswordFailure = (result: ResetPasswordResult, error: ILocalizedError) =>({
  payload: {
    error,
    result
  },
  type: userConstants.RESET_PASSWORD_FAILURE,
})

export const userActions = {
  loginFailedAction,
  loginRequestAction,
  logoutAction,
  resetPassword
};



// WEBPACK FOOTER //
// ./src/actions/user.actions.tsx